import { render, staticRenderFns } from "./ColorPickerIcon.vue?vue&type=template&id=0c9b568b"
import script from "./ColorPickerIcon.vue?vue&type=script&lang=js"
export * from "./ColorPickerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports